import React, { memo } from 'react'

import PartsList from './ListView.SubCat.PartsList'

const SubCategories = ({
  categories,
  partList,
  categoriesPartIndex,
  handleCategoryPartsonClick,
  Link,
}) => (
  <ul className="subcat">
    {categories.map(
      ({ text: subText, link: subLink }) => (
        <PartsList
          key={subText}
          subText={subText}
          subLink={subLink}
          list={partList}
          categoriesPartIndex={categoriesPartIndex}
          handleCategoryPartsonClick={handleCategoryPartsonClick}
          Link={Link}
        />
      ),
    )}
  </ul>
)

export default memo(SubCategories)
